import React, { useEffect, useState } from "react";
import s from "./index.module.css";
//servicios
import gamesService from "../../../api/games/GamesService";
//assets
import {
  loadingRaffles,
} from "../../../store/slices/paginationSlice";
import HandleRequests from "../../Shared/handleRequests/HandleRequests";
import raffleService from "../../../api/raffles/RafflesService";
import { dateFormats } from "../../../helpers/convertDate";
import { Currency } from "../../../helpers/currencyConvert";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CreateRaffle from "./Create";
import Swal from "sweetalert2";
import "dayjs/locale/es";
import "dayjs/locale/pt";
//Material
import Avatar from "@mui/material/Avatar"
import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"
import InputLabel from "@mui/material/InputLabel"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableContainer from "@mui/material/TableContainer"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TextField from "@mui/material/TextField"
import CircularProgress from "@mui/material/CircularProgress"
import Pagination from "@mui/material/Pagination"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import useTranslationException from ".././../../helpers/exceptions";
import { getNoaId } from "../../../utils/session.utils";

// ============================ | SORTEOS | ===================================

export const Sorteos = () => {
  // services
  const dates = dateFormats();

  const { t, i18n } = useTranslation();
  const showExpetion = useTranslationException(t, i18n);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  const { activeOrganization } = useSelector((state) => state.gamma);
  const organizationId = getNoaId()
  const { allGameOffersActive } = useSelector((state) => state.gamma);
  const backError = useSelector((state) => state.errors.rafflesError);
  const { textColor } = useSelector((state) => state.local);
  const { language } = useSelector((state) => state.local);

  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searching, setSearching] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [pageCustom, setPageCustom] = useState(1);

  const [games, setGames] = useState([]);
  const [gameSelected, setGameSelected] = useState(0);
  const [editRaffle, setEditRaffle] = useState(null);
  const [querys, setQuerys] = useState({
    fromCloseDate: null,
    toCloseDate: null,
    fromRaffleDate: null,
    toRaffleDate: null,
    query: "",
  });
  const [newQuerys, setNewQuerys] = useState({
    fromCloseDate: null,
    toCloseDate: null,
    fromRaffleDate: null,
    toRaffleDate: null,
    query: "",
  });
  const [newGameSelected, setNewGameSelected] = useState(0);
  const [sort, setSort] = useState({
    criteria: "DESC",
    field: "",
  });
  const callRaffles = () => {
    setLoading(true);
    if (searching) {
      if (!newGameSelected) {
        setSearching(0);
        Swal.fire({
          icon: "error",
          text: t("pleaseSelectGame"),
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        raffleService
          .getAllRafflesFiltered(
            page,
            pageSize,
            newGameSelected?.modality?.game?.id,
            newGameSelected?.modality?.mode?.id,
            newQuerys,
            dispatch,
            sort,
          )
          .then((res) => {
            setItems(res.content);
            setTotalPages(res.totalPages);
          })
          .then(() => setLoading(false))
          .catch((e) => {
            showExpetion.showErrorModalForServiceException(
              e,
              { icon: "warning" },
              t("anErrorOccurred,TryAgain"),
              t("sorryErrorOcurred"),
            );
            setLoading(false);
          });
      }
    } else {
      raffleService
        .getAllRaffles(organizationId, dispatch, page, pageSize, sort)
        .then((res) => {
          setItems(res.content);
          setTotalPages(res.totalPages);
        })
        .then(() => setLoading(false))
        .catch((e) => {
          showExpetion.showErrorModalForServiceException(
            e,
            { icon: "warning" },
            t("anErrorOccurred,TryAgain"),
            t("sorryErrorOcurred"),
          );
          setLoading(false);
        });
    }
  };

  const handleClean = () => {
    setSearching(0);
    setQuerys({
      fromCloseDate: null,
      toCloseDate: null,
      fromRaffleDate: null,
      toRaffleDate: null,
      query: "",
    });
    setNewQuerys({
      fromCloseDate: null,
      toCloseDate: null,
      fromRaffleDate: null,
      toRaffleDate: null,
      query: "",
    });
    setGameSelected(0);
    setNewGameSelected(0);
  };

  const dateTransformer = (date) => {
    const date2 = new Date(date);
    return date2.toISOString();
  };

  const cellStyles = {
    fontFamily: "Roboto, sans-serif",
    fontSize: ".9rem",
    fontWeight: "400",
    borderBottom: "1px solid rgba(0, 0, 0, 0.455)",
    cursor: "pointer",
  };

  const newRaffle = () => {
    let path = "./create";
    navigate(path);
  };

  useEffect(() => {
    setLoading(true);
    if (!allGameOffersActive) {
      gamesService
        .getAllActivesGameOffers(dispatch)
        .catch((error) => {
          console.log("Error from getAllActivesGameOffers: ", error);
        });
    }
    setLoading(false);
  }, [allGameOffersActive, organizationId, dispatch]);

  async function loadProductos() {
    return await gamesService.getAllGames();
  }

  function attempLoadProductos() {
    dispatch(loadingRaffles(true));
    loadProductos()
      .then((res) => {
        setGames(res.content);
        dispatch(loadingRaffles(false));
        setLoading(false);
      })
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoading(false);
      });
  }

  useEffect(() => {
    setLoading(true);
    attempLoadProductos();
  }, []);

  useEffect(() => {
    if (gameSelected?.modality?.mode?.id === 2) {
      setQuerys((prev) => ({
        ...prev,
        fromCloseDate: null,
        toCloseDate: null,
        fromRaffleDate: null,
        toRaffleDate: null,
      }));
      setNewQuerys((prev) => ({
        ...prev,
        fromCloseDate: null,
        toCloseDate: null,
        fromRaffleDate: null,
        toRaffleDate: null,
      }));
    }
  }, [gameSelected]);

  useEffect(() => {
    callRaffles();
  }, [page, pageSize, searching, sort]);

  const handleSort = (item) => {
    setSort((prev) => ({
      criteria:
        prev.field === item
          ? prev.criteria === "DESC"
            ? "ASC"
            : "DESC"
          : "DESC",
      field: item,
    }));
  };

  // Section: JSX
  return location.pathname.includes("create") ? (
    <CreateRaffle
      editRaffle={editRaffle}
      setEditRaffle={setEditRaffle}
      callAllRaffles={callRaffles}
    />
  ) : (
    <Grid container className={s.container}>
      <HandleRequests error={backError}>
        <Grid item container xs={11} className={s.header}>
          <Grid item xs={12} className={s.titleContainer}>
            <ConfirmationNumberIcon
              sx={{ fontSize: "2rem", color: "primary.main" }}
            />
            <h4>{t("products")}</h4>
            <Button
              className={s.add_btn}
              variant="contained"
              onClick={() => newRaffle()}
            >
              {t("add")}
            </Button>
          </Grid>
        </Grid>
        <Grid item container xs={11} className={s.filtersContainer}>
          <Grid container item xs={12} className={s.gameContainer}>
            <Grid item lg={4} md={5} xs={10} className={s.selector}>
              <InputLabel
                className={s.inputLabel}
              >{`${t("game")}*`}</InputLabel>
              <Select
                value={gameSelected}
                onChange={(e) => setGameSelected(e.target.value)}
              >
                <MenuItem value={0}>{t("all")}</MenuItem>
                {games?.map((g, index) => (
                  <MenuItem key={index} value={g}>
                    {g.modality.game.name}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            {gameSelected?.id ? (
              <Grid item lg={4} md={5} xs={10} className={s.selector}>
                <InputLabel className={s.inputLabel}>
                  {t("DrawAndNum")}
                </InputLabel>
                <TextField
                  value={querys["query"]}
                  onChange={(e) =>
                    setQuerys({ ...querys, query: e.target.value })
                  }
                />
              </Grid>
            ) : null}
            <Grid item lg={3.5} />
          </Grid>
          {gameSelected?.id && gameSelected?.modality?.mode?.id === 1 ? (
            <Grid container item xs={12} className={s.dates}>
              <p>{t("dates")}</p>
              <Grid container item xs={12} className={s.datePickers}>
                <LocalizationProvider
                  dateAdapter={AdapterDayjs}
                  adapterLocale={language}
                >
                  <Grid item lg={2.6} md={4} className={s.date}>
                    <h3
                      style={{
                        fontSize: "1rem",
                        textAlign: "start",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {t("fromRaffleDate")}
                    </h3>
                    <DesktopDatePicker
                      label={"dd/mm/aaaa"}
                      autoOk
                      inputFormat="DD/MM/YYYY"
                      inputProps={{
                        readOnly: true,
                      }}
                      value={querys["fromRaffleDate"]}
                      onChange={(e) => {
                        const dateToSet = dateTransformer(e.$d);
                        setQuerys({ ...querys, fromRaffleDate: dateToSet });
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Grid>
                  <Grid item lg={2.6} md={4} className={s.date}>
                    <h3
                      style={{
                        fontSize: "1rem",
                        textAlign: "start",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {t("toRaffleDate")}
                    </h3>
                    <DesktopDatePicker
                      label={"dd/mm/aaaa"}
                      autoOk
                      inputProps={{
                        readOnly: true,
                      }}
                      inputFormat="DD/MM/YYYY"
                      value={querys["toRaffleDate"]}
                      onChange={(e) => {
                        const dateToSet = dateTransformer(e.$d);
                        setQuerys({ ...querys, toRaffleDate: dateToSet });
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Grid>
                  <Grid item lg={2.6} md={4} className={s.date}>
                    <h3
                      style={{
                        fontSize: "1rem",
                        textAlign: "start",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {t("fromCloseDate")}
                    </h3>
                    <DesktopDatePicker
                      label={"dd/mm/aaaa"}
                      autoOk
                      inputProps={{
                        readOnly: true,
                      }}
                      inputFormat="DD/MM/YYYY"
                      value={querys["fromCloseDate"]}
                      onChange={(e) => {
                        const dateToSet = dateTransformer(e.$d);
                        setQuerys({ ...querys, fromCloseDate: dateToSet });
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Grid>
                  <Grid item lg={2.6} md={4} className={s.date}>
                    <h3
                      style={{
                        fontSize: "1rem",
                        textAlign: "start",
                        marginTop: "5px",
                        marginBottom: "5px",
                      }}
                    >
                      {t("toCloseDate")}
                    </h3>
                    <DesktopDatePicker
                      label={"dd/mm/aaaa"}
                      autoOk
                      inputFormat="DD/MM/YYYY"
                      value={querys["toCloseDate"]}
                      inputProps={{
                        readOnly: true,
                      }}
                      onChange={(e) => {
                        const dateToSet = dateTransformer(e.$d);
                        setQuerys({ ...querys, toCloseDate: dateToSet });
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Grid>
                </LocalizationProvider>
              </Grid>
            </Grid>
          ) : null}

          <Grid item lg={12} md={12} xs={12} sx={{ marginTop: 2 }}>
            <Button
              variant="contained"
              disabled={!gameSelected}
              sx={{ color: textColor, backgroundColor: "primary.main" }}
              onClick={() => {
                setNewGameSelected(gameSelected);
                setNewQuerys(querys);
                setPage(1);
                setSearching((prev) => prev + 1);
              }}
            >
              {t("consult")}
            </Button>
            {searching ? (
              <Button
                variant="contained"
                sx={{
                  color: textColor,
                  backgroundColor: "primary.main",
                  ml: 2,
                }}
                onClick={handleClean}
              >
                {t("clearFilters")}
              </Button>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>

        <Grid item container xs={11} className={s.data}>
          {loading ? (
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "400px",
              }}
            >
              <CircularProgress size={"4rem"} />
            </Grid>
          ) : items?.length ? (
            <TableContainer className={s.tableContainer}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("number")}
                    >
                      {`${t("number")} ${sort.field === "number" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("status")}
                    >
                      {`${t("state")} ${sort.field === "status" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("game.name")}
                    >
                      {`${t("game")} ${sort.field === "game.name" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("lottery.name")}
                    >
                      {`${t("lottery")} ${sort.field === "lottery.name" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("serie")}
                    >
                      {`${t("serie")} ${sort.field === "serie" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("price")}
                    >
                      {`${t("sellPrice")} ${sort.field === "price" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("raffleDate")}
                    >
                      {`${t("drawDate")} ${sort.field === "raffleDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("openDate")}
                    >
                      {`${t("opening")} ${sort.field === "openDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("createDate")}
                    >
                      {`${t("creationDate")} ${sort.field === "createDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("expirationDate")}
                    >
                      {`${t("dateOfExpiry")} ${sort.field === "expirationDate" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: "primary.main",
                        color: textColor,
                        fontSize: ".9rem",
                        fontWeight: 500,
                        fontFamily: "Roboto, sans-Serif",
                      }}
                      onClick={() => handleSort("edit")}
                    >
                      {`${t("edit")} ${sort.field === "edit" ? (sort.criteria === "DESC" ? "▼" : "▲") : ""}`}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items?.map((item, i) => {
                    return (
                      <React.Fragment key={i}>
                        <TableRow
                          sx={{
                            "&:hover": { backgroundColor: "secondary.light" },
                          }}
                        >
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item.number || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item.status === "RELEASED"
                              ? t("active")
                              : t("inactive")}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            <Avatar
                              alt=""
                              src={item.game.image}
                              sx={{ width: 32, height: 32 }}
                            />
                            {item.game.name}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item.lottery.name}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {item.serie || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            <Currency value={item.price} />
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {dates.formatDate(item.raffleDate) || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {dates.formatDate(item.openDate) || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {dates.formatDate(item.createDate) || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            {dates.formatDate(item.expirationDate) || "-"}
                          </TableCell>
                          <TableCell
                            sx={{
                              ...cellStyles,
                              backgroundColor:
                                i % 2 === 0 ? "#dbdbdb76" : "#dbdbdd12",
                            }}
                          >
                            <EditRoundedIcon
                              className={s.iconbtn}
                              sx={{ color: "primary.dark" }}
                              onClick={() => {
                                setEditRaffle(item);
                                newRaffle();
                              }}
                            />
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "300px",
                fontSize: "2rem",
                fontWeight: 300,
              }}
            >
              {t("noResults")}
            </Grid>
          )}
        </Grid>
        {totalPages ? (
          <Grid
            item
            container
            xs={7}
            sx={{ justifyContent: "space-evenly", alignItems: "center", mb: 5 }}
          >
            <Select
              value={pageSize}
              onChange={(e) => setPageSize(e.target.value)}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>
            <Pagination
              count={totalPages || 1}
              showFirstButton
              showLastButton
              page={page}
              onChange={(e, v) => setPage(v)}
              color={"secondary"}
              disabled={loading}
            />
            <form>
              <input
                type="number"
                className={s.insertPaginate}
                onChange={(e) => setPageCustom(e.target.value * 1)}
              />
              <Button
                sx={{ ml: 1 }}
                variant="contained"
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  if (pageCustom <= totalPages) {
                    setPage(pageCustom);
                  }
                }}
              >
                Ir
              </Button>
            </form>
          </Grid>
        ) : (
          <></>
        )}
      </HandleRequests>
    </Grid>
  );
};
